<div class="grid">
  <h2>{{ "pages.passwordRequest.title" | translate }}</h2>

  <!-- Account exists, registration never confirmed -->
  <ng-container *ngIf="unconfirmed">
    <nb-alert outline="warning" role="alert">
      <p class="alert-title">
        <b>{{ "pages.passwordRequest.unconfirmedTitle" | translate }}</b>
      </p>
      <p class="alert-message">
        {{ "pages.passwordRequest.unconfirmedDescription" | translate }}
      </p>
    </nb-alert>

    <button
      *ngIf="!resendSuccess"
      nbButton
      status="primary"
      [nbSpinner]="resendLoading"
      nbSpinnerStatus="control"
      [disabled]="resendLoading"
      (click)="resendConfirmation()"
    >
      {{ "pages.passwordRequest.resendButton" | translate }}
    </button>

    <p class="status-success" *ngIf="resendSuccess">
      {{ "pages.passwordRequest.resendSuccess" | translate }}
    </p>
    <p class="caption status-danger" *ngIf="resendError">
      {{ resendError | translate }}
    </p>
  </ng-container>

  <!-- Link requested -->
  <ng-container *ngIf="sent && !unconfirmed">
    <h5>{{ "pages.passwordRequest.sentDescription" | translate }}</h5>
    <button nbButton status="primary" (click)="toLogin()">
      {{ "buttons.toLogin" | translate }}
    </button>
  </ng-container>

  <!-- The form -->
  <form *ngIf="!sent && !unconfirmed" (ngSubmit)="submit()">
    <h5>{{ "pages.passwordRequest.description" | translate }}</h5>

    <nb-alert *ngIf="error" outline="danger" role="alert">
      {{ error | translate }}
    </nb-alert>

    <input
      nbInput
      fullWidth
      type="email"
      name="email"
      [(ngModel)]="email"
      autocomplete="email"
      autofocus
      [placeholder]="'pages.passwordRequest.emailPlaceholder' | translate"
    />

    <button
      nbButton
      status="primary"
      type="submit"
      fullWidth
      [nbSpinner]="loading"
      nbSpinnerStatus="control"
      [disabled]="!email || loading"
    >
      {{ "pages.passwordRequest.submit" | translate }}
    </button>
  </form>
</div>
